import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Villa Marceau';
const SITE_URL = 'https://www.villamarceau.fr';
const DEFAULT_IMG = `${SITE_URL}/images/hero-bg-v2.jpeg`;

/**
 * Composant SEO — injecte les balises <head> pour chaque page.
 * @param {string} title        Titre unique de la page (sans suffixe site)
 * @param {string} description  Meta description
 * @param {string} canonical    URL canonique (ex: "/commander-en-ligne")
 * @param {string} image        URL absolue de l'image Open Graph
 * @param {boolean} noindex     Mettre à true UNIQUEMENT pour admin/panier/etc.
 */
export default function SEO({ title, description, canonical = '/', image = DEFAULT_IMG, noindex = false }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Concept Store Bohème, Tapis & Décoration à Tours`;
  const canonicalUrl = `${SITE_URL}${canonical}`;

  return (
    <Helmet>
      <html lang="fr" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="fr_FR" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
